import { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import { Site } from 'src/redux/jira/types';
import { publishUiEvent } from 'src/utils/analytics/publish';

import backlogSvg from './backlog.svg';
import messages from './empty-state.i18n';
import { Description, Image, OpenJiraButton } from './empty-state.styled';

export type Props = {
  site?: Site;
};

const NoIssuesInRelevantProjectsEmptyState = (props: Props) => {
  const { site } = props;

  const handleOpenJiraLinkClick = () => {
    publishUiEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'noIssuesInRelevantProjectsOpenJiraLinkButton',
      source: 'repositoryJiraScreen',
    });
  };

  return (
    <Fragment>
      <Image alt="" src={backlogSvg} />
      <h3>
        <FormattedMessage {...messages.noIssuesHeader} />
      </h3>
      <Description>
        <FormattedMessage {...messages.noIssuesDescription} />
      </Description>
      <OpenJiraButton
        href={site?.cloudUrl}
        appearance="link"
        target="_blank"
        onClick={handleOpenJiraLinkClick}
      >
        <FormattedMessage {...messages.openJiraLink} />
      </OpenJiraButton>
    </Fragment>
  );
};

export default NoIssuesInRelevantProjectsEmptyState;
